import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RegionFeatureOverrideable, RegionFeatures } from '../shared/region-features.model';
import { ProofOfDeliveryRule } from '../shared/pod-rule.model';
import { FeatureUtils } from '../shared/feature-utils';
import { InheritableOnOffFeature, OnOffFeature } from '../shared/on-off-feature.model';
import { ControlContainer, NgForm } from '@angular/forms';
import { AutoGroupCollections } from '../shared/auto-group-collections.model';
import { EmailValidatorService } from '../../shared/services/email-validator.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { RegionFeatureOverrideAbility } from '../shared/region-feature-override-ability.model';
import { RadioOption } from '../../shared/radio-option';
import { RegionTmsSyncSchedulerTime } from '../shared/region-tmssync-scheduletime.model';
import { take } from 'rxjs/operators';
import { RegionFeatureDisplayMode } from './region-feature-new-editor/region-feature-new.component';

@Component({
  selector: 'app-region-features-editor',
  templateUrl: './region-features-editor.component.html',
  styleUrls: ['./region-features-editor.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class RegionFeaturesEditorComponent implements OnInit {

  @Input()
  features = new RegionFeatures();

  @Input()
  tmsSyncWindows: RegionTmsSyncSchedulerTime[] = [RegionTmsSyncSchedulerTime.UTC_02];

  @Input()
  form: NgForm;

  @Input()
  regionId: string;

  @Output()
  errorMessageKey = new EventEmitter<string>();

  RegionFeatureDisplayMode = RegionFeatureDisplayMode;
  driverAssignmentModes = FeatureUtils.DRIVER_ASSIGNMENT_MODE;
  proofOfDeliveryRules  = FeatureUtils.PROOF_OF_DELIVERY_RULES;
  photoPodRules                  = FeatureUtils.PHOTO_POD_RULES;
  inheritableOnOffPossibleValues = FeatureUtils.INHERITABLE_ON_OFF_POSSIBLE_VALUES;
  onOffPossibleValues            = FeatureUtils.ON_OFF_POSSIBLE_VALUES;
  autoGroupCollections  = FeatureUtils.AUTO_GROUP_COLLECTION;
  automaticTripCreationOrderTypes = FeatureUtils.AUTOMATIC_TRIP_CREATION_ORDER_TYPES;

  ProofOfDeliveryRule = ProofOfDeliveryRule;
  RegionFeature = RegionFeatureOverrideable;
  OnOffFeature = OnOffFeature;

  regionTmsSyncScheduledTimes: RadioOption[] = [
    {
      labelKey: 'regions.form.tms-sync-time.utc00',
      value: RegionTmsSyncSchedulerTime.UTC_00,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc01',
      value: RegionTmsSyncSchedulerTime.UTC_01,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc02',
      value: RegionTmsSyncSchedulerTime.UTC_02,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc03',
      value: RegionTmsSyncSchedulerTime.UTC_03,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc04',
      value: RegionTmsSyncSchedulerTime.UTC_04,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc05',
      value: RegionTmsSyncSchedulerTime.UTC_05,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc06',
      value: RegionTmsSyncSchedulerTime.UTC_06,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc07',
      value: RegionTmsSyncSchedulerTime.UTC_07,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc08',
      value: RegionTmsSyncSchedulerTime.UTC_08,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc09',
      value: RegionTmsSyncSchedulerTime.UTC_09,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc10',
      value: RegionTmsSyncSchedulerTime.UTC_10,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc11',
      value: RegionTmsSyncSchedulerTime.UTC_11,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc12',
      value: RegionTmsSyncSchedulerTime.UTC_12,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc13',
      value: RegionTmsSyncSchedulerTime.UTC_13,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc14',
      value: RegionTmsSyncSchedulerTime.UTC_14,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc15',
      value: RegionTmsSyncSchedulerTime.UTC_15,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc16',
      value: RegionTmsSyncSchedulerTime.UTC_16,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc17',
      value: RegionTmsSyncSchedulerTime.UTC_17,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc18',
      value: RegionTmsSyncSchedulerTime.UTC_18,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc19',
      value: RegionTmsSyncSchedulerTime.UTC_19,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc20',
      value: RegionTmsSyncSchedulerTime.UTC_20,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc21',
      value: RegionTmsSyncSchedulerTime.UTC_21,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc22',
      value: RegionTmsSyncSchedulerTime.UTC_22,
    },
    {
      labelKey: 'regions.form.tms-sync-time.utc23',
      value: RegionTmsSyncSchedulerTime.UTC_23,
    },
  ];

  constructor(
    private emailValidatorService: EmailValidatorService,
    private toastrService: ToastrService,
    private translate: TranslateService,
  ) {
    this.regionTmsSyncScheduledTimes.forEach(time => {
      time.label = time.labelKey;
      this.translate.get(time.labelKey)
        .pipe(take(1))
        .subscribe(label => {
          time.label = label;
        });
    })
  }

  ngOnInit() {
    this.form.control.setValidators(this.tripCreationConflictValidator.bind(this));
    this.form.control.updateValueAndValidity();
  }

  sapMultiCollectionsCheckinValueChange() {
    if (this.features.sapMultiCollectionsCheckinValue === InheritableOnOffFeature.ON) {
      this.features.autoGroupCollectionsValue = AutoGroupCollections.YES
    }
  }

  orderTypesChanged() {
    if (!this.features.automaticTripCreationValue) {
      this.features.automaticTripCreationOrderTypes = [];
    }
    this.form.form.markAsDirty();
  }

  emailValidator = (email: string) => {
    if (this.emailValidatorService.isEmailValid(email)) {
      return new Promise((resolve) => resolve(email));
    } else {
      this.toastrService.error(this.translate.instant('selects.errors.email'))
    }
  }

  tripCreationConflictValidator(): {conflict: boolean} {
    if (this.features.tmsLoadsSynchronization.forced && this.features.automaticTripCreationOverrideAbility === RegionFeatureOverrideAbility.NOT_OVERRIDABLE && this.features.automaticTripCreationValue) {
      this.errorMessageKey.emit('feature-profiles.trip-gen-and-trip-creation-forced-not-allowed')
      return { conflict: true };
    }
    this.errorMessageKey.emit(null);
    return null;
  }
}
